// ** React Imports
import React, {Fragment, useEffect, useState} from 'react'

// ** Table Data & Columns
import { columns } from './data'

// ** Third Party Components
import ReactPaginate from 'react-paginate'
import DataTable from 'react-data-table-component'
import {ChevronDown, PlusCircle} from 'react-feather'

// ** Reactstrap Imports
import {
    Row,
    Col,
    Card,
    Input,
    Label,
    CardTitle,
    CardHeader, Button
} from 'reactstrap'

// ** Styles
import '@styles/react/libs/tables/react-dataTable-component.scss'

// ** Utils
import CreateArea from "./components/create-area/create-area";
import EditArea from "./components/edit-area/edit-area";
import DeleteArea from "./components/delete-area/delete-area";
import axios from "axios";

const AreaList = () => {
    // ** States
    const [showCreateAreaModal, setShowCreateAreaModal] = useState(false);
    const [showEditAreaModal, setShowEditAreaModal] = useState(false);
    const [showDeleteAreaModal, setShowDeleteAreaModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(0)
    const [searchValue, setSearchValue] = useState({
        areaName: '',
        areaId: ''
    })
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState([]);
    const [rowEdit, setRowEdit] = useState(null);

    const toggleCreateAreaModal = (show) => {
        setShowCreateAreaModal(show);
    }
    const toggleEditAreaModal = (show, row) => {
        setShowEditAreaModal(show);
        setRowEdit(row);
    }
    const toggleDeleteAreaModal = (show, row) => {
        setShowDeleteAreaModal(show);
        setRowEdit(row);
    }
    const getAreas = async () => {
        const res =  await axios.get(`${process.env.REACT_APP_API_URL}/areas/assigned`);
        const areaList = res.data.data.map(a => {
            return {
                areaId: a.id,
                areaName: a.name
            }
        })
        setData(areaList);
        setFilteredData(areaList);
    }
    useEffect(() => {
        getAreas();
    }, []);

    // ** Function to handle filter
    const handleFilter = e => {
        const target = e.target.name;
        const value = e.target.value;

        if (target === 'areaId') {
            const reg = new RegExp('^[0-9]+$');
            if (!reg.test(value) && value) {
                e.preventDefault();
                e.stopPropagation();
                return
            }
        }

        let updatedData = []
        setSearchValue({
            ...searchValue,
            [target]: value
        });

        if (!value.length) {
            setFilteredData(data);
            return;
        }

        updatedData = data.filter(item => {
            const includes = item[target].toString().toLowerCase().includes(value.toLowerCase())
            if (includes) {
                return includes;
            }
        })
        setFilteredData(updatedData)

    }

    // ** Function to handle Pagination
    const handlePagination = page => {
        setCurrentPage(page.selected)
    }

    // ** Pagination Previous Component
    const Previous = () => {
        return (
            <Fragment>
                <span className='align-middle d-none d-md-inline-block'>Anterior</span>
            </Fragment>
        )
    }

    // ** Pagination Next Component
    const Next = () => {
        return (
            <Fragment>
                <span className='align-middle d-none d-md-inline-block'>Siguiente</span>
            </Fragment>
        )
    }

    // ** Custom Pagination
    const CustomPagination = () => (
        <ReactPaginate
            previousLabel={<Previous />}
            nextLabel={<Next />}
            forcePage={currentPage}
            onPageChange={page => handlePagination(page)}
            pageCount={Math.ceil(filteredData.length / 25) || 1}
            breakLabel={'...'}
            pageRangeDisplayed={2}
            marginPagesDisplayed={2}
            activeClassName={'active'}
            pageClassName={'page-item'}
            nextLinkClassName={'page-link'}
            nextClassName={'page-item next'}
            previousClassName={'page-item prev'}
            previousLinkClassName={'page-link'}
            pageLinkClassName={'page-link'}
            breakClassName='page-item'
            breakLinkClassName='page-link'
            containerClassName={'pagination react-paginate pagination-sm justify-content-end pe-1 mt-1'}
        />
    )

    return (
        <Fragment>
            <Card>
                <CardHeader className='flex-md-row flex-column align-md-items-center align-items-start border-bottom'>
                    <CardTitle tag='h4'>Area</CardTitle>
                </CardHeader>

                <Row className='justify-content-end mx-0'>
                    <Col className='d-flex justify-content-end mt-1' md='6' sm='12'>
                        <Button
                            onClick={() => {
                                setRowEdit(null);
                                toggleCreateAreaModal(true);
                            }}
                            color='primary'
                            className='btn-sm'>
                            <PlusCircle size={16} />
                            <span className={'ms-1'}>Crear Area</span>
                        </Button>
                    </Col>
                </Row>
                < hr/>
                <Row className='mx-0'>
                    <Col className='d-flex align-items-center justify-content-start mt-1' md='5' sm='6'>
                        <Label className='me-1' for='areaId'>
                            Id area
                        </Label>

                        <Input
                            name={'areaId'}
                            className='dataTable-filter mb-50'
                            type='text'
                            bsSize='sm'
                            id={'areaId'}
                            value={searchValue.areaId}
                            onChange={handleFilter}
                        />
                    </Col>
                    <Col className='d-flex align-items-center justify-content-start mt-1' md='5' sm='6'>
                        <Label className='me-1' for='areaName'>
                            Nombre de area
                        </Label>

                        <Input
                            name={'areaName'}
                            className='dataTable-filter mb-50'
                            type='text'
                            bsSize='sm'
                            id={'areaName'}
                            value={searchValue.areaName}
                            onChange={handleFilter}
                        />
                    </Col>
                </Row>
                    <div className='react-dataTable'>
                        <DataTable
                            noHeader
                            pagination
                            columns={columns(toggleEditAreaModal, toggleDeleteAreaModal)}
                            paginationPerPage={25}
                            className='react-dataTable'
                            sortIcon={<ChevronDown size={10} />}
                            paginationComponent={CustomPagination}
                            paginationDefaultPage={currentPage + 1}
                            data={filteredData}
                        />
                    </div>
            </Card>


            <CreateArea isOpen={showCreateAreaModal} handleClose={toggleCreateAreaModal}/>
            <EditArea isOpen={showEditAreaModal} handleClose={toggleEditAreaModal} item={rowEdit}/>
            <DeleteArea isOpen={showDeleteAreaModal} handleClose={toggleDeleteAreaModal} item={rowEdit}/>

        </Fragment>
    )
}

export default AreaList
